module.exports = ".ba-am-chart {\n  width: 100%;\n  height: inherit; }\n"